var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 10L28 6H20L16 10H32Z",
    fill: "#A6DA27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10V40C11 42.2 12.8 44 15 44H33C35.2 44 37 42.2 37 40V10H11Z",
    fill: "#CAF16B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 39H23.5C22.7 39 22 38.3 22 37.5V18.5C22 17.7 22.7 17 23.5 17H24.5C25.3 17 26 17.7 26 18.5V37.5C26 38.3 25.3 39 24.5 39Z",
    fill: "#A5D139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 39C30.7 39 30 38.3 30 37.5V18.5C30 17.7 30.7 17 31.5 17C32.3 17 33 17.7 33 18.5V37.5C33 38.3 32.3 39 31.5 39Z",
    fill: "#A5D139"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 39C15.7 39 15 38.3 15 37.5V18.5C15 17.7 15.7 17 16.5 17C17.3 17 18 17.7 18 18.5V37.5C18 38.3 17.3 39 16.5 39Z",
    fill: "#A5D139"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H37C38.1 8 39 8.9 39 10V12H9V10C9 8.9 9.9 8 11 8Z",
    fill: "#A6DA27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.963612939230dff92622894010d1ac23.svg";
export { ForwardRef as ReactComponent };